export const VNode = {
    name: 'VNode',
    functional: true,
    props: ['nodes'],
    render(h: any, context: any) {
        return h('span', context.data, [context.props.nodes]);
    },
};